import { useState } from 'react';

import { useBaseAuthenticated } from '@cloudquery/base-users';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { GridMoreVertIcon } from '@mui/x-data-grid';

import { useNavigate } from 'react-router';
import { MenuActions, useMenu } from 'shared/base';

import { DeleteReportDialog } from '../dialogs/deleteReportDialog';
import { getReportUrl } from '../utils/navigation';

export function ReportActionMenu({
  buttonVariant = 'text',
  id,
}: {
  buttonVariant?: 'text' | 'outlined';
  id: string;
}) {
  const navigate = useNavigate();
  const { currentMembership } = useBaseAuthenticated();
  const { menuProps, menuToggleProps } = useMenu();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const actions = [
    {
      icon: EditIcon,
      id: 'edit',
      label: 'Edit',
      onClick: () => navigate(getReportUrl(id, currentMembership.team.name, true)),
    },
    {
      icon: DeleteIcon,
      id: 'delete',
      isDangerous: true,
      label: 'Delete',
      onClick: () => setOpenDeleteDialog(true),
    },
  ];

  return (
    <>
      <DeleteReportDialog
        onClose={() => setOpenDeleteDialog(false)}
        open={openDeleteDialog}
        reportId={id}
      />
      <Button
        color="secondary"
        sx={{ minWidth: 0, px: 0.75 }}
        variant={buttonVariant}
        {...menuToggleProps}
      >
        <GridMoreVertIcon />
      </Button>
      <MenuActions actions={actions as any} iconPosition="start" {...menuProps} />
    </>
  );
}
